// extracted by mini-css-extract-plugin
export var infoRow = "_mf-2";
export var labelContainer = "_mf-0";
export var rightInfo = "_mf-1";